import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom-v5-compat';

import { Button } from 'ui-components/components/button';
import { DeprecatedTabs } from 'ui-components/components/DEPRECATED/tabs';
import { DeprecatedTab } from 'ui-components/components/DEPRECATED/tabs/tab';
import { DeprecatedTabButton } from 'ui-components/components/DEPRECATED/tabs/tab-button';
import { DeprecatedTabContent } from 'ui-components/components/DEPRECATED/tabs/tab-content';
import { useAsyncSafeState } from 'ui-components/hooks/async-safe';

import saveStyle from '../components/save-bar/style.module.less';
import SettingsPageWrapper from '../settings-page-wrapper';
import { CarrierPackages } from './carrier-packages';
import { CARRIER } from './constants';
import { CustomPackages } from './custom-packages';
import { messages, tabMessages } from './messages';
import { PackageSets } from './package-sets';
import style from './packages-settings.module.less';
import { useMultiPackageShipments } from '../../../feature-flags/hooks/use-multi-package-shipments';
import { useQuery } from '../../../hooks/routing/use-query';

const CARRIER_PACKAGES_TAB = 'carrier';
export const CUSTOM_PACKAGES_TAB = 'custom';
export const CUSTOM_PACKAGE_SETS_TAB = 'sets';

const content = {
  carrier: CarrierPackages,
  custom: CustomPackages,
  sets: PackageSets,
};

const tabs = Object.keys(content);

export const PackagesPage = () => {
  const queryParams = useQuery();
  const navigate = useNavigate();
  const tabParam = queryParams.get('tab');
  const defaultTab = CARRIER_PACKAGES_TAB;
  const initialTab = tabs.includes(tabParam) ? tabParam : defaultTab;
  const [isSaving, setIsSaving] = useAsyncSafeState(false);
  const [selectedTab, setSelectedTab] = useAsyncSafeState(initialTab);
  const enableMultiPackageShipments = useMultiPackageShipments();

  const handleOnSave = useCallback((saving = true) => setIsSaving(saving), [setIsSaving]);
  const handleOnClickTab = useCallback(
    (tab) => {
      setSelectedTab(tab);
      navigate(`/settings/packages?tab=${tab}`, { replace: true });
    },
    [navigate, setSelectedTab],
  );

  return (
    <>
      <SettingsPageWrapper isTabbed messages={messages}>
        <DeprecatedTabs bodyClassName={style['tabs-body-override']} className={style.tabs} headerClassName={style['tabs-header-override']}>
          {tabs.map((tab) => {
            if (tab === 'sets' && !enableMultiPackageShipments) {
              return null;
            }
            const Content = content[tab];
            return (
              <DeprecatedTab key={tab} selected={selectedTab === tab}>
                <DeprecatedTabButton
                  className={style['tab-button']}
                  onClick={() => handleOnClickTab(tab)}
                  selectedClassName={style['selected-tab-button']}
                  theme='file-tab'
                >
                  <FormattedMessage {...tabMessages[tab]} />
                </DeprecatedTabButton>
                <DeprecatedTabContent className={style['tab-content']}>
                  <Content handleOnSave={handleOnSave} isSaving={isSaving} />
                </DeprecatedTabContent>
              </DeprecatedTab>
            );
          })}
        </DeprecatedTabs>
      </SettingsPageWrapper>
      {selectedTab === CARRIER && (
        <div className={saveStyle.pinned}>
          <Button disabled={isSaving} onClick={() => handleOnSave()} theme='primary'>
            {isSaving ? <FormattedMessage {...messages['saving-button']} /> : <FormattedMessage {...messages['save-button']} />}
          </Button>
        </div>
      )}
    </>
  );
};
